module.exports = __webpack_public_path__ + "static/media/hightechnl.43417887.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/hightechnl.webp
// module id = 640
// module chunks = 0